import React from 'react';
import { EDITOR_PRESETS, isPresetPartial } from '../utils/editorPresets';
import { fieldLabelClass } from './EditorFormFields';

const ddmm = (isoDay) => (isoDay ? `${isoDay.slice(8, 10)}/${isoDay.slice(5, 7)}` : '');

const BasicPresetPicker = ({ selectedId, availability, submitting, onSelect }) => (
  <div>
    <label className={fieldLabelClass}>¿Qué período querés mostrar?</label>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
      {EDITOR_PRESETS.map((preset) => {
        const available = availability[preset.id] !== false;
        const selected = selectedId === preset.id;
        const firstDate = availability.firstDate;
        const partial = available && isPresetPartial(preset.id, firstDate);
        return (
          <button
            key={preset.id}
            type="button"
            onClick={() => onSelect(preset.id)}
            disabled={submitting || !available}
            aria-pressed={selected}
            title={!available && firstDate ? `La cámara tiene fotos desde el ${ddmm(firstDate)}` : undefined}
            className={`text-left p-4 rounded-xl border transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
              selected
                ? 'border-blue-500 bg-blue-50 ring-2 ring-blue-500'
                : 'border-gray-200 bg-white hover:bg-gray-50'
            }`}
          >
            <span className="block text-sm font-semibold text-gray-800">{preset.label}</span>
            <span className="block text-xs text-gray-500 mt-0.5">
              Video de {preset.durationSeconds} segundos
              {partial && ` · desde el ${ddmm(firstDate)}`}
              {!available && firstDate && ` · hay fotos desde el ${ddmm(firstDate)}`}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);

export default BasicPresetPicker;
